// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1S_Cf","upload":"Small_upload__20Bb4","imageWrap":"Small_imageWrap__OG1zU","removeBtn":"Small_removeBtn__2rtXT"};